import { type ArrayOfObjects } from '../types/ArrayOfObjects';

export function getIterableArrayOfObjects<Obj extends object>(array: Obj[]): ArrayOfObjects<Obj> {
  return array.map((obj, index) => ({ ...obj, id: index }));
}
